import { QualificationInterface } from "../../interfaces/QualificationInterface";

export const getQualificationOptions = (
    qualifications?: QualificationInterface[],
): { value: string; label: string }[] => {
    if (!qualifications) {
        return [];
    }

    return (
        qualifications.map((item: QualificationInterface) => ({
            label: item.name,
            value: item.id.toString(),
        })) || []
    );
};
